import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { scrollToContainerBottom } from '../Signup.utils';
import Checkbox from '../../../Components/ComponentCheckbox';
import Radios from '../../../Components/ComponentRadios';
import ContinueButton from '../components/ContinueButton';
import SignupFormAction from '../components/SignupFormAction';
import { AssetTypes, UserToUpdate, UserFields, MaritalTypes, Steps, ScrollDelayTimeoutMs, RealEstatePurchaseTypes, AdditionalFields } from '../SignupForm.constants';
import T from '../Locale';
const { MARITAL, ASSETS, CHILDREN, CHILDREN_OUTSIDE_RELATIONSHIP, MARRIAGE, RESIDENCE, PARTNER_PRESENT, ENABLED_DOCUMENTS_AND_TIME_BOOKING } = UserFields;
const { MARITAL_MARRIED, MARITAL_RELATIONSHIP, MARITAL_SINGLE } = MaritalTypes;
const { MARITAL_STATUS_AND_BOOKING } = Steps;
const MaritalStatusAndBookingStep = ({ user, updateUser, onSave, showBookingField, showRealEstateQuestion, setCurrentStep, currentStep, updateAdditionalData }) => {
    const [fieldsToDisplay, setFieldsToDisplay] = useState([]);
    const [resetFlow, setResetFlow] = useState(false);
    const containerRef = useRef(null);
    const userAssets = user[ASSETS] != null ? user[ASSETS] : [];
    const realEstatePurchaseTypes = user[UserFields.REAL_ESTATE_PURCHASE_TYPE] != null ? user[UserFields.REAL_ESTATE_PURCHASE_TYPE] : [];
    let scrollDelayTimeout = null;
    useEffect(() => {
        return () => {
            if (scrollDelayTimeout != null) {
                clearTimeout(scrollDelayTimeout);
            }
        };
    }, []);
    return (_jsxs("div", Object.assign({ ref: containerRef }, { children: [_jsx(SignupFormAction, Object.assign({ title: T('partner.signup.marital.title') }, { children: _jsx(Radios, { name: MARITAL, options: (() => {
                        const options = {};
                        if (!user.partner_present) {
                            options[T('partner.signup.marital.single')] = MARITAL_SINGLE;
                        }
                        options[T('partner.signup.marital.partnership')] = MARITAL_RELATIONSHIP;
                        options[T('partner.signup.marital.married')] = MARITAL_MARRIED;
                        return options;
                    })(), selectedValue: user[MARITAL], onSelect: (value) => handleChangeField(MARITAL, value), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) })), !resetFlow && (_jsxs(_Fragment, { children: [fieldsToDisplay.includes(RESIDENCE) && (_jsx(SignupFormAction, Object.assign({ title: T('partner.signup.living') }, { children: _jsx(Radios, { name: RESIDENCE, options: { [T('misc.yes')]: true, [T('misc.no')]: false }, selectedValue: user[RESIDENCE], onSelect: (value) => handleChangeField(RESIDENCE, value), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) }))), fieldsToDisplay.includes(MARRIAGE) && (_jsx(SignupFormAction, Object.assign({ title: T('partner.signup.marriagePlanned') }, { children: _jsx(Radios, { name: MARRIAGE, options: { [T('misc.yes')]: true, [T('misc.no')]: false }, selectedValue: user[MARRIAGE], onSelect: (value) => handleChangeField(MARRIAGE, value), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) }))), fieldsToDisplay.includes(CHILDREN) && (_jsx(SignupFormAction, Object.assign({ title: user[MARITAL] === MARITAL_SINGLE ? T('partner.signup.childrenAlone') : T('partner.signup.childrenPartner') }, { children: _jsx(Radios, { name: CHILDREN, options: { [T('misc.yes')]: true, [T('misc.no')]: false }, selectedValue: user[CHILDREN], onSelect: (value) => handleChangeField(CHILDREN, value), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) }))), fieldsToDisplay.includes(CHILDREN_OUTSIDE_RELATIONSHIP) && (_jsx(SignupFormAction, Object.assign({ title: user.partner_present ? T('partner.signup.ownChildrenPartner') : T('partner.signup.ownChildrenAlone') }, { children: _jsx(Radios, { name: CHILDREN_OUTSIDE_RELATIONSHIP, options: { [T('misc.yes')]: true, [T('misc.no')]: false }, selectedValue: user[CHILDREN_OUTSIDE_RELATIONSHIP], onSelect: (value) => handleChangeField(CHILDREN_OUTSIDE_RELATIONSHIP, value), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) }))), fieldsToDisplay.includes(ASSETS) && (_jsx(SignupFormAction, Object.assign({ title: user[PARTNER_PRESENT] ? T('partner.signup.assets.titlePartner') : T('partner.signup.assets.titleAlone') }, { children: AssetTypes.map((type) => (_jsx(Checkbox, { label: T(`partner.signup.assets.${type}`), id: `${ASSETS}-${type}`, classes: userAssets.includes(type) ? 'partner_button_100 button bg-green-100' : 'partner_button_100 button hollow green', onChange: () => handleChangeField(UserFields.ASSETS, type), hideInput: true }, type))) }))), fieldsToDisplay.includes(UserFields.IS_REAL_ESTATE_PLANNED) && (_jsx(SignupFormAction, Object.assign({ title: T('partner.realEstatePurchasePlanned.title') }, { children: _jsx(Radios, { name: UserFields.IS_REAL_ESTATE_PLANNED, options: { [T('misc.yes')]: true, [T('misc.no')]: false }, selectedValue: user[UserFields.IS_REAL_ESTATE_PLANNED], onSelect: (value) => handleChangeField(UserFields.IS_REAL_ESTATE_PLANNED, value), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) }))), fieldsToDisplay.includes(UserFields.REAL_ESTATE_PURCHASE_TYPE) && (_jsx(SignupFormAction, Object.assign({ title: T('partner.realEstatePurchaseTypes.title') }, { children: RealEstatePurchaseTypes.map((type) => (_jsx(Checkbox, { label: T(`partner.realEstatePurchaseTypes.${type}`), id: `${UserFields.REAL_ESTATE_PURCHASE_TYPE}-${type}`, classes: realEstatePurchaseTypes.includes(type) ? 'partner_button_100 button bg-green-100' : 'partner_button_100 button hollow green', onChange: () => handleChangeField(UserFields.REAL_ESTATE_PURCHASE_TYPE, type), hideInput: true }, type))) }))), fieldsToDisplay.includes(UserFields.ENABLED_DOCUMENTS_AND_TIME_BOOKING) && (_jsxs(SignupFormAction, Object.assign({ title: `${T('partner.shouldShowDocuments.title')}:` }, { children: [_jsxs("div", Object.assign({ className: 'w-full md:w-auto' }, { children: [_jsx("p", Object.assign({ className: 'font-light' }, { children: T('partner.shouldShowDocuments.text1') })), _jsx("p", Object.assign({ className: 'font-light' }, { children: T('partner.shouldShowDocuments.text2') }))] })), _jsx("div", Object.assign({ className: 'mt-5' }, { children: _jsx(Radios, { name: ENABLED_DOCUMENTS_AND_TIME_BOOKING, options: { [T('partner.shouldShowDocuments.yes')]: true, [T('partner.shouldShowDocuments.no')]: false }, selectedValue: user[ENABLED_DOCUMENTS_AND_TIME_BOOKING], onSelect: (value) => handleChangeField(UserFields.ENABLED_DOCUMENTS_AND_TIME_BOOKING, value), classNamesDefault: 'partner_button_25 button hollow green', classNamesSelected: 'partner_button_25 button bg-green-100' }) }))] })))] })), getIsContinueButtonVisible() && _jsx(ContinueButton, { id: 'marital-and-booking', onClick: onSave })] })));
    function getIsContinueButtonVisible() {
        if (onSave == null) {
            return false;
        }
        if (!fieldsToDisplay.includes(ASSETS)) {
            return false;
        }
        if (showBookingField && user[ENABLED_DOCUMENTS_AND_TIME_BOOKING] == null) {
            return false;
        }
        if (showRealEstateQuestion && (user === null || user === void 0 ? void 0 : user[UserFields.IS_REAL_ESTATE_PLANNED]) == null) {
            return false;
        }
        return true;
    }
    function handleChangeField(name, value) {
        var _a, _b;
        const prevFields = [...fieldsToDisplay];
        const multiOptionQuestion = [UserFields.ASSETS, UserFields.REAL_ESTATE_PURCHASE_TYPE];
        if (!multiOptionQuestion.includes(name)) {
            // Show next question or reset/hide all the questions after target one
            const fieldsToRemove = prevFields.splice(prevFields.indexOf(name) + 1).filter(field => field !== name);
            updateUser({ [name]: value }, UserToUpdate.BOTH, fieldsToRemove);
            // Rerender question checkboxes and radio buttons
            if (fieldsToRemove.length > 0) {
                setResetFlow(true);
                setTimeout(() => setResetFlow(false));
            }
            // Reset the flow to the current step if any question answer from following step was changed. Deselect selected products and booking
            if (currentStep !== MARITAL_STATUS_AND_BOOKING) {
                setCurrentStep(MARITAL_STATUS_AND_BOOKING);
                updateAdditionalData({ [AdditionalFields.PRODUCTS]: [], [AdditionalFields.BOOKING]: {} });
            }
        }
        else {
            // Those question are not affecting the flow
            const values = (_a = user === null || user === void 0 ? void 0 : user[name]) !== null && _a !== void 0 ? _a : [];
            const isRealEstateQuestionSelected = name === UserFields.IS_REAL_ESTATE_PLANNED && !value;
            const realEstatePurchaseTypes = (_b = user === null || user === void 0 ? void 0 : user[UserFields.REAL_ESTATE_PURCHASE_TYPE]) !== null && _b !== void 0 ? _b : [];
            if (Array.isArray(values)) {
                let updatedValues = values.includes(value) ? values.filter(v => v !== value) : [...values, value];
                // Make sure real estate purchase types property gets omit if real estate question value is false
                if (isRealEstateQuestionSelected && realEstatePurchaseTypes.length > 0) {
                    updatedValues = [];
                }
                updateUser({ [name]: updatedValues }, UserToUpdate.BOTH);
            }
        }
        const validNextFields = Array.from(new Set([...prevFields, ...getFieldsToDisplay(name, value)]));
        setFieldsToDisplay(validNextFields);
        scrollToBottom();
    }
    function getFieldsToDisplay(name, value) {
        if (name === UserFields.MARITAL) {
            if (value === MARITAL_RELATIONSHIP) {
                return [RESIDENCE];
            }
            else {
                return [CHILDREN];
            }
        }
        if (name === RESIDENCE) {
            return [MARRIAGE];
        }
        if (name === MARRIAGE) {
            return [CHILDREN];
        }
        if (name === CHILDREN) {
            if (user[PARTNER_PRESENT] || user[MARITAL] !== MARITAL_SINGLE) {
                return [CHILDREN_OUTSIDE_RELATIONSHIP];
            }
            if (showRealEstateQuestion) {
                return [ASSETS, UserFields.IS_REAL_ESTATE_PLANNED];
            }
            if (showBookingField) {
                return [ASSETS, UserFields.ENABLED_DOCUMENTS_AND_TIME_BOOKING];
            }
            return [ASSETS];
        }
        if (name === CHILDREN_OUTSIDE_RELATIONSHIP) {
            if (showRealEstateQuestion) {
                return [ASSETS, UserFields.IS_REAL_ESTATE_PLANNED];
            }
            if (showBookingField) {
                return [ASSETS, UserFields.ENABLED_DOCUMENTS_AND_TIME_BOOKING];
            }
            return [ASSETS];
        }
        if (name === UserFields.IS_REAL_ESTATE_PLANNED) {
            let nextFields = [];
            if (value) {
                nextFields = [UserFields.REAL_ESTATE_PURCHASE_TYPE];
            }
            if (showBookingField) {
                nextFields = [...nextFields, UserFields.ENABLED_DOCUMENTS_AND_TIME_BOOKING];
            }
            return nextFields;
        }
        return [];
    }
    function scrollToBottom() {
        if (typeof onSave !== 'function') {
            return;
        }
        if (scrollDelayTimeout != null) {
            clearTimeout(scrollDelayTimeout);
        }
        scrollDelayTimeout = setTimeout(() => {
            scrollToContainerBottom(containerRef.current);
        }, ScrollDelayTimeoutMs);
    }
};
MaritalStatusAndBookingStep.propTypes = {
    user: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    showBookingField: PropTypes.bool,
    showRealEstateQuestion: PropTypes.bool,
    updateAdditionalData: PropTypes.func
};
export default MaritalStatusAndBookingStep;
